export default "__VITE_ASSET__DvQRLv$S__"